import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signin from '../pages/auth/Signin';
import Dashboard from '../pages/[admin]/Dashboard';
import AuthLayout from '../layouts/AuthLayout';
import Students from '../pages/[admin]/Student/Students';
import SettingsPage from '../components/AppSettings/SettingsPage';

import NotFound from '../pages/NotFound';
import AttendanceManagement from '../components/Attendance/AttendaceManagement';
import StudentMarksManagement from '../components/Marks/StudentMarksManagement';
import RegistrationPage from '../pages/RegistrationPage';
import AdminSignIn from '../pages/auth/AdminSignIn';
import SuperAdminPage from '../pages/SuperAdminPage';
import ConfigurationPage from '../components/Configurations/ConfigurationPage';
import WithAuth from '../hoc/WithAuth';
import ErrorBoundary from '../components/ErrorBoundary';
import FallBackUi from '../components/FallBackUi';
import PaymentsPage from '../components/PaymentsPage';
import HistoryPage from '../components/History/HistoryPage';
import StudentFullDetails from '../components/Student/StudentFullDetails';
import MigrationPage from '../components/migration/MigrationPage';
import UnauthorizedPage from '../components/UnauthorizedPage';

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route
        path='/'
        element={
          <AuthLayout>
            <Signin />
          </AuthLayout>
        }
      />
      <Route
        path='/signin'
        element={
          <AuthLayout>
            <Signin />
          </AuthLayout>
        }
      />
      <Route
        path='/admin/signin'
        element={
          <AuthLayout>
            <AdminSignIn />
          </AuthLayout>
        }
      />
      <Route
        path='/registration'
        element={
          <AuthLayout>
            <RegistrationPage />
          </AuthLayout>
        }
      />
      {/* <Route
        path='/signup'
        element={
          <AuthLayout>
            <Signup />
          </AuthLayout>
        }
      /> */}
      <Route path='/admin/dashboard' element={<SuperAdminPage />} />
      <Route
        path='/dashboard'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <Dashboard></Dashboard>{' '}
            </ErrorBoundary>
          </WithAuth>
        }
      />
      <Route
        path='/students'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <Students></Students>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/payments'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <PaymentsPage></PaymentsPage>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/students/studentDetails'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <StudentFullDetails></StudentFullDetails>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/attendence'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <AttendanceManagement></AttendanceManagement>{' '}
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/marks'
        element={
          <WithAuth>
            {' '}
            <ErrorBoundary fallback={Fallbackui}>
              <StudentMarksManagement></StudentMarksManagement>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/configurations'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <ConfigurationPage></ConfigurationPage>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/history'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <HistoryPage></HistoryPage>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/migration'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <MigrationPage></MigrationPage>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      />
      <Route
        path='/settings'
        element={
          <WithAuth>
            <ErrorBoundary fallback={Fallbackui}>
              <SettingsPage></SettingsPage>
            </ErrorBoundary>{' '}
          </WithAuth>
        }
      ></Route>
      <Route path='/unauthorized' element={<UnauthorizedPage />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  </Router>
);

export default AppRoutes;
const Fallbackui = ({ error, resetErrorBoundary }) => (
  <FallBackUi error={error} resetErrorBoundary={resetErrorBoundary} />
);
